import { prepareSchedule, getPreparedScheduleGroups, groupIndexedArray, I18nService, timestampToISO } from "@perxis-auto/shared";
import { APP } from "../../../config/app.js";
import { getDealershipDepartment } from "./getDealershipDepartment.js";
function formatDays(grouppedDays) {
  const { i18n } = I18nService.getInstance();
  return grouppedDays.map(
    (group) => group.map((day) => i18n.t("widgets.dealerMap.schedule.weekDay", { value: day, ns: APP.name })).join("-")
  ).join(", ");
}
function formatTimes(times, fullDay) {
  const { i18n } = I18nService.getInstance();
  if (fullDay) {
    return i18n.t("widgets.dealerMap.schedule.fullDay", { ns: APP.name });
  }
  return times.map(
    ([start, end]) => `${i18n.t("widgets.dealerMap.schedule.workTime", { value: timestampToISO(start), ns: APP.name })}-${i18n.t("widgets.dealerMap.schedule.workTime", { value: timestampToISO(end), ns: APP.name })}`
  ).join(", ");
}
const formatDealershipWorkTime = (dealershipItem) => {
  var _a;
  const department = getDealershipDepartment(dealershipItem);
  if (!department || !((_a = department.schedules) == null ? void 0 : _a.length)) {
    return [];
  }
  const preparedSchedule = prepareSchedule(department.schedules);
  const aggregatedSchedule = getPreparedScheduleGroups(preparedSchedule);
  return aggregatedSchedule.map((item) => {
    const { days, times, fullDay } = item || {};
    const grouppedDays = groupIndexedArray(days);
    return `${formatDays(grouppedDays)}: ${formatTimes(times, fullDay)}`;
  });
};
export {
  formatDealershipWorkTime
};
